export const AGY_CLI_VERSION = '1.0.14';
